import * as types from '../actions/actionTypes';

const initialState = {
  isSwitching : false,
  activeStep: 0,
};

export default function(state = initialState, action) {

  switch(action.type) {

    case types.SET_SQFT_TUTORIAL_STEP:
      if (state.isSwitching) {
        return Object.assign({}, state) // don't do anything until animation will finish
      }

      return Object.assign({}, state, {
        activeStep: action.payload.activeStep <= 0 ? 0 : action.payload.activeStep
      });

    case types.SET_SQFT_TUTORIAL_SWITCHING:
      return Object.assign({}, state, {
        ...action.payload
      });

  }

  return state;

}
